<template src="./Index.html"></template>

<script>
export default {
  components: {},
  created() {
    if (this.$route.query.params != null) {
      this.filters.jobType = this.$route.query.params;

    }
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
    this.$store.dispatch("lookups/getSpecialties");

  },
  computed: {

    specialties() {
      return [
        { value: 0, label: "الكل" }, ...this.$store.state.lookups.specialties];
    },
   
    courseTypes() {
      return [
        { value: 0, label: "الكل" }, ...this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.CourseTypes
      )];
    },
    
    
    pageCount() {
      return Math.ceil(
        this.totalItems /
        this.filters.pageSize
      );
    },
  },
  data() {
    return {
     subtitle: "",
      items: [
        {
          text: "التقارير",
        },
        {
          text: "تقرير دورات الموظفين  ",
        },
      ],
      itemId: 0,
      view: 0,
      data: [],
      totalItems: 0,
      filters: {
        page: 1,
        pageSize: 10,
        specialtyId: 0,
        courseTypeId: 0,
      },
      headers: [
        {
          text: "الرقم التسلسلي ",
          value: "employeeNo",
          sortable: false,
          align: "start",
        },
        {
          text: "اسم الموظف",
          value: "fullName",
          sortable: false,
          align: "start",
        },
        {
          text: "الادارة",
          value: "administrationName",
          sortable: false,
          align: "start",
        },
        {
          text: "القسم",
          value: "departmentName",
          sortable: false,
          align: "start",
        },
          {
          text: "الوحدة",
          value: "unitName",
          sortable: false,
          align: "start",
        },
        {
          text: "عدد الدورات ",
          value: "coursesCount",
          sortable: false,
          align: "start",
        },
       ],
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reports/getEmployeeCourses", this.filters).then((res) => {
        this.data = res.data;
        this.totalItems = res.totalItems;
      });
    },
    download() {
      let filters = {
        specialtyId: this.filters.specialtyId,
        courseTypeId: this.filters.courseTypeId,
      };
      const paramsString = Object.entries(filters)
        .filter(([, val]) => val !== null)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      window.open(`/api/reports/EmployeeCoursesExcel?${paramsString}`, "_blank");
    },

  },
};
</script>
